import React, { useEffect, useState, memo } from 'react';
import dateformat from 'dateformat';
import { srpColorConfig } from '../../config/config';
import { isMobileView } from '../../Common/utils';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Icon from '../../../../stories/core-components/IconsSelector'
import MWebCalendar from '../../CommonResp/CalendarMWEB/MWebCalendar/MWebCalendar'
import { useSelector } from 'react-redux';
import { routeDataSelector } from '../../RoutePage/redux/selectors';
function PrivateBusCard(props) {

    const { privateBuses, moveToFunnel } = props;
    const [showMwebCal, setShowMwebCal] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState('')
    const [loadPtag, setLoadPtag] = useState(false)
    const changeCalendar = () => {
        setShowMwebCal(!showMwebCal)
    }
    let view = [];
    useEffect(()=>{
        setLoadPtag(true)
    },[])
    for (let index in privateBuses) {
        const { fd, fl, bid, fh, card_BPDP_Info, reddeal, go_safe, primo, rs, sl, op_url = '', amenities, biurl, ptag} = privateBuses[index];
        const { cr, bt, rating, rc, dt, du, fr, to, at, dd, aws, rd, gps} = fl[0];
        const numberOfRestStops = rs && rs.length ? true : false;
        const { bp, dp } = card_BPDP_Info;
        const { BPN } = bp && bp.length ? bp[0] : '';
        const { DPN } = dp && dp.length ? dp[0] : '';
        const arrivalDate = dd ? dateformat(new Date(dd), "dS mmm") : ''
        const { tf, pp } = fd;
        const isRedDealApplicable = reddeal && Object.keys(reddeal).length ? true : false;
        const busSeatCount = rd && rd.length ? rd[0].SeatsAvailable : 0;
        const {offerDesc} = reddeal

        const data = useSelector(routeDataSelector);
        const {src, dest} = data
        const operatorUrl = (() => {
            if (op_url) {
                return `${__ENV_CONFIG__.__GOIBIBO__}${op_url}`;
            }
            return '';
        })();
        
        view.push(
            <div className='seoListingContainer'>

                {showMwebCal &&
                    view.splice(0, 0, <MWebCalendar showCalendar={showMwebCal} moveToFunnelParams={{src, dest, ...privateBuses[selectedIndex]}} changeCalendar={changeCalendar} page={'srp'} isBusCard={'private'} />)
                }
                <tr className="seoListingTable" key={bid + fh} onClick={() => {
                    if (isMobileView()) {
                        console.log('index buscard ', privateBuses[index], index, privateBuses[index])
                         moveToFunnel({ page: 'seatlayout', data: privateBuses[index] })
                        // setShowMwebCal(!showMwebCal)
                        setSelectedIndex(index)
                    }
                }}>
                    <td>
                        <div className="travellerInfoSection">
                            <div className="travellerName">
                                <p className="travelAgency truncatelistHeading">
                                    {operatorUrl ? <a className="interlinkcardHeading" href={operatorUrl}>{cr}</a> : <>{cr}</>}
                                </p>
                                <p className="rtcbusType">
                                    {bt}
                                </p>
                                {rating && rating > 0 ? <p className="RatingReview">
                                    <span className="RatingTag" style={{ background: srpColorConfig[Math.round(rating)], borderColor: srpColorConfig[Math.round(rating)] }}>
                                        <span className="bold">{rating}</span>/5
                                    </span> {rc && rc > 0 ? <>&nbsp;  {rc} Reviews</> : null}
                                </p> : null}
                                <div className="makeFlex alignItemCenter tagsName">
                                    {primo ? <p className="marginRight10"><img data-src="https://gos3.ibcdn.com/primo-1627630262.png" className="lazyload" width="47px;" height="26px;" alt="primoLogo" /></p> : null}
                                    {go_safe ? <p><img data-src="https://gos3.ibcdn.com/goSafelogo-1591083260.png" className="lazyload" width="58px;" height="18px;" alt="go safe" /></p> : null}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="makeFlex alignItemCenter">
                            <div className="FromInfo">
                                <p>{dt}</p>
                                <p className="">{BPN || fr}</p>
                            </div>
                            <div className="travelTime">
                                <p>{du}</p>
                                {numberOfRestStops ? <p>{rs.length ? `${rs.length} rest stop` : '--'}</p> : null}
                            </div>
                            <div className="FromInfo">
                                <p>{at} {arrivalDate ? <span className="appendLeft5">{arrivalDate}</span> : null}</p>
                                <p className="">{DPN || to}</p>
                            </div>
                        </div>
                    </td>
                    <td>
                        {isRedDealApplicable ? <p className="price">{`₹${pp}`}</p> : null}
                        {tf !== undefined && isRedDealApplicable ? <p className="orgPrice lineThrough" style={{ textDecoration: 'line-through' }}>{`₹${tf}`}</p> : tf ? <p className="price"> {`₹${tf}`}  </p> : null}
                        {offerDesc && (
                            <p className='OfferDetailsDiv' style={offerDesc!== 'goDeal applied' ? {width : '150px'}: {width:'auto'}}>
                                <Icon
                                    name="OffersIcon"
                                    styleProps={{ fill: '#f4a900', width: '1.7rem', height: '1.7rem' }}
                                />
                                <span className='OfferTxtBusCard'>{offerDesc}</span>
                            </p>
                        )}
                    </td>
                    <td>
                        <span className="selectSeat" style={{ cursor: "pointer" }} onClick={() => {
                            moveToFunnel({ page: 'srp', routeId: fh })
                        }}>SELECT SEAT</span>
                        {aws ? <p className="windowSeat">
                            {aws} window seat  &nbsp;
                            {/* <span className="windowSeatIcon"></span> */}
                            <img data-src="https://gos3.ibcdn.com/window_seat-1631700169.png" className="lazyload" alt="window" style={{ width: "15px", height: "15px" }}></img>
                        </p> : null}
                        {busSeatCount ? <p className="seatLeft">{busSeatCount} seats left</p> : null}
                         <div className="mobileOnly priceGoDealMobile">
                            {tf !== undefined && isRedDealApplicable? <p className="crossPrice" >{`₹ ${tf}`}</p> : 
                           tf ? <p className="listingPrice listingPriceMobile" style={{ fontWeight: 700 }}>{`₹ ${tf}`}</p> : null}
                            {isRedDealApplicable ? <p className="listingPrice listingPriceMobile" style={{ fontWeight: 700 }}>{`₹ ${pp}`}</p> : null}
                            {offerDesc && (
                                <p className='OfferDetailsDiv' style={offerDesc !== 'goDeal applied' ? { width: '150px' } : { width: 'auto' }}>
                                    <Icon
                                        name="OffersIcon"
                                        styleProps={{ fill: '#f4a900', width: '1.7rem', height: '1.7rem' }}
                                    />
                                    <span className='OfferTxtBusCard'>{offerDesc}</span>
                                </p>
                            )}
                        </div>
                    </td>
                </tr>
                {
                    loadPtag &&  <div className="pTagContainer">
                    {ptag && ptag.length > 0 ?
                        <div className='PersuasionTag'>
                            <span><img src={'https://gos3.ibcdn.com/green_star-1645531773.png'} alt="People_choice" />{'People choice for'}</span>
                            <ul>
                                {ptag.slice(0, 5).map(item => (
                                    <li className='licontainer' key={item?.id}>
                                        <span>{'\u2022'} {item?.title}</span>
                                    </li>
                                ))}
                            </ul>

                        </div>
                        : <></>
                    }
                </div>
                }
                {
                    loadPtag &&
                    <div className="busDetailsContainer desktopOnly" >
                    {gps ? (
                        <div className='InnerContentLayoutDiv'>
                            <Icon
                                name="LiveBus"
                                styleProps={{ fill: '#647a97', width: '1.8rem', height: '1.8rem' }}
                            />
                            <span className='TextSpanBusCard'>Live Tracking</span>
                        </div>
                    ) : null}

                    <div className='AmminitiesInnerLayoutDiv'>
                        <div className='BoadingElink'
                            onClick={() => {
                                moveToFunnel({ page: 'srp', routeId: fh, section: 'boarding_dropping' })
                            }}
                        >
                            Boarding & Dropping Points
                        </div>
                        <div className='BoadingElink'
                            onClick={() => {
                                moveToFunnel({ page: 'srp', routeId: fh, section: 'amenities_photos' });
                            }}
                        >
                            Amenities, Policies & Bus Details
                        </div>
                    </div>
                </div>
                }
                {sl && sl.length ? <tr className="mobileOnly">
                    <td className="FeaturesListSection">
                        <ul className="featuresList">
                            {sl.map((data, index) => {
                                const { title } = data;
                                return (
                                    <li key={title + index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img className="lazyload" data-src="https://www.goibibo.com/static/images/bus/icons/amen.png" height='16' width='22' alt="feature" style={{ height: "16px", maxWidth: "22px", marginRight: "6px" }} />
                                        <span>{title}</span>
                                    </li>
                                )
                            })}
                        </ul>
                    </td>
                </tr> : null}
            </div>
        )
    }

    return (
        <>
            {view}
        </>
    )
}

export default memo(PrivateBusCard)